import { render, staticRenderFns } from "./videoLogin.vue?vue&type=template&id=589af1e0"
import script from "./videoLogin.vue?vue&type=script&lang=js"
export * from "./videoLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports